var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolNewChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13V7M7 10H13M10 17.7096C11.6745 17.7093 13.3034 17.1637 14.6402 16.1553C15.977 15.147 16.9492 13.7307 17.4096 12.1208C17.87 10.5108 17.7937 8.79476 17.1921 7.23206C16.5905 5.66936 15.4965 4.34504 14.0754 3.4594C12.6543 2.57375 10.9834 2.17494 9.3155 2.32328C7.6476 2.47163 6.07335 3.15905 4.83086 4.2816C3.58836 5.40414 2.74518 6.90076 2.42885 8.54509C2.11251 10.1894 2.34022 11.8921 3.07754 13.3955C3.16754 13.5788 3.19754 13.7855 3.15171 13.9838L2.47171 16.9305C2.45254 17.0132 2.45473 17.0994 2.4781 17.181C2.50146 17.2626 2.54521 17.3369 2.60524 17.3969C2.66526 17.457 2.73958 17.5007 2.82119 17.5241C2.9028 17.5474 2.98901 17.5496 3.07171 17.5305L6.01754 16.8496C6.21643 16.8061 6.42427 16.8326 6.60587 16.9246C7.66203 17.4433 8.8234 17.7119 10 17.7096Z",
    stroke: "#414651",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolNewChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_new_chat.42725c6ffebda0b2cf1a9bc0c3ea71dd.svg";